module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/38.3868aa1d.png";